import { useState } from "react";
import "./resources.css";
import resourcesData from "./resource.json";

export default function JonasResources() {
	const [activeNav, setActiveNav] = useState("all");

	const resources = resourcesData;

	// const navItems = resources.map((r) => ({ name: r.cat, icon: r.icon }));

	return (
		<>
			{/* <div className="newsbar">
				🔥🔥🔥 I just launched the "Ultimate REACT Course"! The perfect
				companion to my JavaScript course.{" "}
				<a href="#">Start learning today →</a>
			</div> */}

			<div className="main-background">
				<header className="master-header">
					<div className="master-header__box">
						<h1 className="master-header__heading">
							Soham's Resources for Hand-Crafting
							<br />
							Beautiful and Performant Websites
						</h1>
					</div>
				</header>
			</div>

			<nav className="group-nav">
				<ul>
					<li>
						<a
							href="#development-tools"
							onClick={(e) => {
								e.preventDefault();
								setActiveNav("Development tools");
								document
									.getElementById("development-tools")
									?.scrollIntoView({ behavior: "smooth" });
							}}
						>
							<span className="group-nav--icon">🔨</span>
							Tools
						</a>
					</li>
					<li>
						<a
							href="#html5-resources"
							onClick={(e) => {
								e.preventDefault();
								setActiveNav("HTML5 Resources");
								document
									.getElementById("html5-resources")
									?.scrollIntoView({ behavior: "smooth" });
							}}
						>
							<span className="group-nav--icon">💻</span>
							HTML
						</a>
					</li>
					<li>
						<a
							href="#css-resources"
							onClick={(e) => {
								e.preventDefault();
								setActiveNav("CSS Resources");
								document
									.getElementById("css-resources")
									?.scrollIntoView({ behavior: "smooth" });
							}}
						>
							<span className="group-nav--icon">🎨</span>
							CSS
						</a>
					</li>
					<li>
						<a
							href="#javascript-resources"
							onClick={(e) => {
								e.preventDefault();
								setActiveNav("JavaScript Resources");
								document
									.getElementById("javascript-resources")
									?.scrollIntoView({ behavior: "smooth" });
							}}
						>
							<span className="group-nav--icon">⚡</span>
							JS
						</a>
					</li>
					<li>
						<a
							href="#fonts-and-typography-tools"
							onClick={(e) => {
								e.preventDefault();
								setActiveNav("Fonts and Typography Tools");
								document
									.getElementById("fonts-and-typography-tools")
									?.scrollIntoView({ behavior: "smooth" });
							}}
						>
							<span className="group-nav--icon">📝</span>
							Fonts
						</a>
					</li>
					<li>
						<a
							href="#great-colors-and-tools"
							onClick={(e) => {
								e.preventDefault();
								setActiveNav("Great Colors and Tools");
								document
									.getElementById("great-colors-and-tools")
									?.scrollIntoView({ behavior: "smooth" });
							}}
						>
							<span className="group-nav--icon">🌈</span>
							Colors
						</a>
					</li>
					<li>
						<a
							href="#images-and-videos"
							onClick={(e) => {
								e.preventDefault();
								setActiveNav("Images and Videos");
								document
									.getElementById("images-and-videos")
									?.scrollIntoView({ behavior: "smooth" });
							}}
						>
							<span className="group-nav--icon">🖼️</span>
							Images
						</a>
					</li>
					<li>
						<a
							href="#best-icons-and-tools"
							onClick={(e) => {
								e.preventDefault();
								setActiveNav("Best Icons and Tools");
								document
									.getElementById("best-icons-and-tools")
									?.scrollIntoView({ behavior: "smooth" });
							}}
						>
							<span className="group-nav--icon">⭐</span>
							Icons
						</a>
					</li>
					<li>
						<a
							href="#find-design-inspiration"
							onClick={(e) => {
								e.preventDefault();
								setActiveNav("Find Design Inspiration");
								document
									.getElementById("find-design-inspiration")
									?.scrollIntoView({ behavior: "smooth" });
							}}
						>
							<span className="group-nav--icon">💡</span>
							Design
						</a>
					</li>
					<li>
						<a
							href="#popular-blogs--communities"
							onClick={(e) => {
								e.preventDefault();
								setActiveNav("Popular Blogs & Communities");
								document
									.getElementById("popular-blogs--communities")
									?.scrollIntoView({ behavior: "smooth" });
							}}
						>
							<span className="group-nav--icon">👥</span>
							Blogs
						</a>
					</li>
					<li>
						<a
							href="#testing,-optimization-and-deployment"
							onClick={(e) => {
								e.preventDefault();
								setActiveNav("Testing, Optimization and Deployment");
								document
									.getElementById("testing,-optimization-and-deployment")
									?.scrollIntoView({ behavior: "smooth" });
							}}
						>
							<span className="group-nav--icon">⚡</span>
							Speed
						</a>
					</li>
					<li>
						<a
							href="#node.js-development"
							onClick={(e) => {
								e.preventDefault();
								setActiveNav("Node.js development");
								document
									.getElementById("node.js-development")
									?.scrollIntoView({ behavior: "smooth" });
							}}
						>
							<span className="group-nav--icon">🟢</span>
							Node.js
						</a>
					</li>
				</ul>
			</nav>

			<main>
				{resources.map((section, idx) => (
					<section
						key={idx}
						id={section.cat
							.toLowerCase()
							.replace(/\s+/g, "-")
							.replace(/&/g, "")}
						className="group"
					>
						<div className="container">
							<h2 className="group__heading">
								<span className="group__heading--icon">
									{section.icon === "ion-ios-hammer"
										? "🔨"
										: section.icon === "ion-ios-code"
										? "💻"
										: section.icon === "ion-ios-color-palette"
										? "🎨"
										: section.icon === "ion-logo-javascript"
										? "⚡"
										: section.icon === "ion-ios-text"
										? "📝"
										: section.icon === "ion-ios-color-filter"
										? "🌈"
										: section.icon === "ion-ios-images"
										? "🖼️"
										: section.icon === "ion-ios-star"
										? "⭐"
										: section.icon === "ion-ios-bulb"
										? "💡"
										: section.icon === "ion-ios-people"
										? "👥"
										: section.icon === "ion-ios-speedometer"
										? "⚡"
										: "🟢"}
								</span>
								{section.cat}
							</h2>
							<div className="container__resource">
								{section.items.map((resource, i) => (
									<div key={i} className="resource">
										<img
											src={`https://${resource.domain}/favicon.ico`}
											onError={(e) => {
												e.target.src = `https://www.google.com/s2/favicons?domain=${resource.domain}&sz=64`;
											}}
											alt=""
											className="resource__logo"
										/>
										<h3
											className={`resource__heading ${
												resource.premium ? "resource__heading--premium" : ""
											}`}
										>
											<a
												href={resource.url}
												target="_blank"
												rel="noopener noreferrer"
												className="resource__link"
											>
												{resource.name}
											</a>
										</h3>
										<p className="resource__text">{resource.desc}</p>
									</div>
								))}
							</div>
						</div>
					</section>
				))}
			</main>

			{/* <div className="optin-section main-background">
				<div className="container">
					<div className="optin">
						<p className="optin__text">
							Join 50,000+ developers and don't miss an update to this list!
						</p>
						<form className="optin__form">
							<input type="text" placeholder="First Name" />
							<input type="email" placeholder="Email Address" />
							<button type="button">YES, PLEASE!</button>
						</form>
					</div>
				</div>
			</div> */}

			<footer>
				<div className="container">
					<div className="footer__text">
						{/* <span>Built with ❤️ in beautiful Algarve, Portugal.</span> */}
						<span>
							© {new Date().getFullYear()} by SimplyWebDev. All rights reserved.
						</span>
						<p className="no-ads">
							No responsibility for the content of linked third-party websites.
							I have not received any compensation for linking any of these
							resources, they are all recommended based on my own personal
							experience ✌️
						</p>
					</div>
				</div>
			</footer>
		</>
	);
}
